module.exports = __webpack_public_path__ + "db7836609ac24050fc4d36cc5f3d44a5.png";